export enum AllowedMimeType {
  IMAGE_PNG = 'image/png',
  IMAGE_JPG = 'image/jpg',
  IMAGE_JPEG = 'image/jpeg',
  APPLICATION_PDF = 'application/pdf',
  APPLICATION_JSON = 'application/json',
}
